export const transferPageTheme = {
  header: {
    bg: 'palette.surface.3',
    borderColor: 'palette.surface.5',
    borderWidth: '1px',
  },
  title: 'palette.tertiary.95',
};
